import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { logout } from '../../../actions/auth';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { useLocation } from 'react-router-dom';

// Image
import hamburger_icon from '../../../img/hamburger_icon.png';
import hamburger_icon_white from '../../../img/hamburger_icon_white.png';
import { toast } from 'react-toastify';
import ProfilePic from '../profile/ProfilePic';
import defaultProfilePic from '../../../img/defaultProfilePic.png';

const hashColor = (name, alternate = false) => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const color = (hash & 0x00ffffff).toString(16).toUpperCase();
  return alternate
    ? color.padStart(6, '0').slice(0, 6)
    : color.padEnd(6, '0').slice(0, 6);
};

const HamburgerNavBar = ({ auth: { user }, logout }) => {
  const [showManageProfile, setShowManageProfile] = useState(false);
  const [paidUser, setPaidUser] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const navigate = useNavigate(); // <-- Initialize useNavigate hook

  const handleLogout = async (e) => {
    e.preventDefault();

    try {
      // Call the logout action
      await logout();

      // Clear the 'isToastShown' item from local storage
      localStorage.removeItem('isToastShown');

      // Navigate to the login page
      navigate('/login');

      // Show a success message
      toast.success('Logged out successfully');
    } catch (error) {
      console.error('Logout failed:', error);
      toast.error('Logout failed. Please try again.');
    }
  };

  useEffect(() => {
    if (user) {
      if (user.is_paid) setPaidUser(true);
      if (user.user_isSuperUser) {
        setShowManageProfile(true);
      }
    }
  }, [user]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const location = useLocation();
  const isPDPlansPage = location.pathname === '/pd-plans';
  const hamburgerIconClass = isPDPlansPage ? 'hamburger-icon-white' : '';

  return (
    <Menu as='div' className='relative inline-block text-left'>
      <div>
        <Menu.Button className='inline-flex w-full justify-center py-2 text-sm font-semibold focus:outline-0'>
          <div className='flex items-center'>
            {/* <ProfilePic defaultProfilePic={defaultProfilePic} /> */}
            {/* {user && user.user_name && (
              <span className={userNameClass}>{user.user_name}</span>
            )} */}
            {user && user.user_name ? (
              <div
                className={`w-10 h-10 flex items-center justify-center rounded-full text-white font-semibold text-lg uppercase shadow-md`}
                style={{
                  background: `linear-gradient(135deg, #${hashColor(
                    user.user_name
                  )} 30%, #${hashColor(user.user_name, true)} 90%)`,
                }}
              >
                {user.user_name
                  .split(' ')
                  .map((name) => name.charAt(0))
                  .join('')}
              </div>
            ) : (
              <img
                src={defaultProfilePic}
                alt='Default Profile'
                className='w-10 h-10 rounded-full shadow-md'
              />
            )}
          </div>
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter='transition ease-out duration-100'
        enterFrom='transform opacity-0 scale-95'
        enterTo='transform opacity-100 scale-100'
        leave='transition ease-in duration-75'
        leaveFrom='transform opacity-100 scale-100'
        leaveTo='transform opacity-0 scale-95'
      >
        <Menu.Items className='absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none'>
          <div className='py-1'>
            <Menu.Item>
              {({ active }) => (
                <span
                  to='/overview'
                  className='navbar-dropdown-list-items px-3 py-2'
                >
                  {user && user.user_name && (
                    <span className='navbar-dropdown-list-user-name'>
                      {user.user_name
                        .split(' ') // Split the name into parts (first name, last name, etc.)
                        .map(
                          (name) =>
                            name.charAt(0).toUpperCase() +
                            name.slice(1).toLowerCase()
                        ) // Capitalize the first letter and make the rest lowercase
                        .join(' ')}{' '}
                      {/* Join the formatted name parts back into a single string */}
                    </span>
                  )}

                  <br />
                  {user && user.user_email && (
                    <span className='navbar-dropdown-list-user-email'>
                      {user.user_email}
                    </span>
                  )}
                </span>
              )}
            </Menu.Item>
          </div>
          <div className='py-1'>
            <Menu.Item>
              {({ active }) => (
                <Link
                  to='/overview'
                  className='navbar-dropdown-list-items hover:bg-hover_4-10 hover:text-gray-700 px-4 py-2 hover:no-underline'
                >
                  {/* <i class='fa-solid fa-house mr-3'></i> */}
                  Home{' '}
                </Link>
              )}
            </Menu.Item>
            <Menu.Item>
              {({ active }) => (
                <Link
                  to='/your-profile'
                  className='navbar-dropdown-list-items hover:bg-hover_4-10 hover:text-gray-700 px-4 py-2 hover:no-underline'
                >
                  {/* <i class='fa-solid fa-user-pen mr-3'></i> */}
                  Your Profile
                </Link>
              )}
            </Menu.Item>

            <Menu.Item>
              {({ active }) => (
                <Link
                  to='/pricing'
                  className='navbar-dropdown-list-items hover:bg-hover_4-10 hover:text-gray-700 px-4 py-2 hover:no-underline'
                >
                  {/* <i class='fa-solid fa-list-check mr-3'></i> */}
                  Plans
                </Link>
              )}
            </Menu.Item>

            <Menu.Item>
              {({ active }) => (
                <a
                  href='https://ecomnext.ai/terms-and-conditions/'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='navbar-dropdown-list-items hover:bg-hover_4-10 hover:text-gray-700 px-4 py-2 hover:no-underline'
                >
                  Terms & Policy
                </a>
              )}
            </Menu.Item>

            <Menu.Item>
              {({ active }) => (
                <Link
                  to='/contact-us'
                  className='navbar-dropdown-list-items hover:bg-hover_4-10 hover:text-gray-700 px-4 py-2 hover:no-underline'
                >
                  {/* <i class='fa-brands fa-wpforms mr-3'></i> */}
                  Contact Us
                </Link>
              )}
            </Menu.Item>
          </div>
          <div className='py-1'>
            <Menu.Item>
              {({ active }) => (
                <Link
                  to='/login'
                  className='hover:bg-hover_4-10 text-secondary_3-10 hover:text-secondary_3-10  block px-4 py-2 text-sm hover:no-underline font-medium'
                  onClick={(e) => handleLogout(e)}
                >
                  <i class='fa-solid fa-arrow-right-from-bracket mr-3'></i>
                  Logout
                </Link>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

HamburgerNavBar.propTypes = {
  logout: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { logout })(HamburgerNavBar);
